<template>
    <div class="px-4 py-12">
        <div v-for="dataset in props.data.datasets" :key="dataset.label" class="relative p-4 w-36 h-36">
            <div
                class="absolute z-10 w-40 h-40 -translate-x-1/2 -translate-y-1/2 bg-red-400 rounded-full top-1/2 left-1/2"
                style="
                    background-image: radial-gradient(green 0, green 50%, transparent 50%, transparent 100%),
                        radial-gradient(red 0, red 50%, transparent 50%, transparent 100%),
                        radial-gradient(white 0, white 60%, transparent 60%),
                        conic-gradient(orange 0, red 130deg, white 130deg, white 230deg, green 230deg, orange 360deg);
                    background-size: 11% 11%, 11% 11%, 100% 100%, 100% 100%;
                    background-repeat: no-repeat;
                    background-position: 9.2% 82.3%, 90.8% 82.3%, center center, center center;
                "
            ></div>

            <div
                class="absolute z-20 -translate-x-1/2 -translate-y-1/2 bg-gray-200 rounded-full w-36 h-36 top-1/2 left-1/2"
            ></div>

            <div class="absolute z-30 w-20 h-20 rotate-45 -translate-x-1/2 bg-white -bottom-8 left-1/2"></div>

            <div
                class="absolute top-0 z-40 w-4 -ml-2 transition-all duration-500 origin-center h-36 left-1/2"
                :style="{
                    transform: 'rotate(' + angle + 'deg)',
                }"
            >
                <div class="w-4 h-4 mt-2 rotate-45 bg-gray-600"></div>
            </div>

            <div
                class="relative z-50 flex flex-col items-center justify-center font-medium tracking-tighter bg-white rounded-full w-28 h-28 shadow-natural-sm"
            >
                <div class="text-4xl">
                    {{ dataset.data[0] }}
                </div>
                <div class="text-sm text-gray-600">{{ percent ? percent : 0 }}%</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    data?: any;
    minAngle?: number;
    maxAngle?: number;
    minValue?: number;
    maxValue?: number;
}

const props = withDefaults(defineProps<Props>(), {
    data: null,
    minAngle: -140,
    maxAngle: 140,
    minValue: 0,
    maxValue: 600,
});

const range = computed(() => {
    return props.maxAngle - props.minAngle;
});

const percent = computed(() => {
    return Math.round(((props.data.datasets[0].data[0] - props.minValue) / (props.maxValue - props.minValue)) * 100);
});

const angle = computed(() => {
    return (percent.value / 100) * range.value + props.minAngle;
});
</script>
